<template>
  <v-dialog :value="isCloseSession" persistent max-width="500">
    <v-card class="white white--text login-block pt-5" color="navbar">
      <h3 class="text-center text--white mb-3">
        Активный сеанс работы в Личном кабинете закончился. Для продолжения работы вам необходимо осуществить повторный
        вход в Личный кабинет
      </h3>
      <div class="text-center w-100 d-block mb-3">
        <v-icon size="55" color="write"> mdi-account-clock-outline </v-icon>
      </div>
      <v-card-text class="signin-card-login">
        <v-form ref="form" lazy-validation class="white--text">
          <v-text-field :value="user.username" label="Логин" prepend-icon="mdi-face" type="text" :readonly="true" />
          <v-text-field
            v-model="model.password"
            clearable
            :rules="[rules.required, rules.password]"
            label="Пароль"
            prepend-icon="mdi-lock"
            :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
            :type="showPassword ? 'text' : 'password'"
            color="white"
            class="white--text"
            @click:append="showPassword = !showPassword"
            @keyup.enter="login"
          />
          <transition name="slide-x-transition">
            <v-row v-show="loginError" class="pl-3 text-center">
              <v-icon color="error"> mdi-alert-circle </v-icon>
              <strong class="pt-0 my-0 ml-2 error--text"> Введен неверный пароль </strong>
            </v-row>
          </transition>
        </v-form>
        <v-row>
          <v-btn color="primary" class="ma-2" width="150" @click="logout"> Выход </v-btn>
          <v-spacer />
          <v-btn color="primary" class="ma-2" width="150" @click="login"> Продлить сессию </v-btn>
        </v-row>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script lang="ts">
import { mapActions, mapState } from 'pinia';
import { defineComponent } from 'vue';
import { useUserStore } from '@/store/user';
import { useMainStore, useSystemStore } from '@/store/stores';
export default defineComponent({
  name: 'Reauthorization',
  data() {
    return {
      model: {
        password: <string>'',
      },
      showPassword: <boolean>false,
      loginError: <boolean>false,
      rules: {
        required: (val: string) => !!val || 'Обязательно для заполнения',
        password: (val: string) => /^[\d\w]{1,18}$/i.test(val) || 'Неправильный формат',
      },
    };
  },
  computed: {
    ...mapState(useSystemStore, {
      isCloseSession: 'isCloseSession',
    }),
    ...mapState(useUserStore, {
      user: 'user',
    }),
  },
  methods: {
    ...mapActions(useSystemStore, {
      setSession: 'setSession',
    }),
    ...mapActions(useMainStore, {
      logoutStore: 'logout',
    }),
    login() {
      //@ts-ignore
      if (this.$refs.form.validate()) {
        const params = new URLSearchParams();
        params.append('username', this.user.username);
        params.append('password', this.model.password);
        this.$axios
          .post(this.$uri.login, params, { skipErrorMsgByStatuses: [401] })
          .then(() => {
            this.setSession(true);
          })
          .catch((e) => {
            if (e.response.status === 401) {
              this.loginError = true;
              setTimeout(() => {
                this.loginError = false;
              }, 2000);
            }
          });
      }
    },
    async logout() {
      await this.logoutStore();
      this.setSession(true);
      this.$router.push({ name: 'Login' });
    },
  },
});
</script>
<style scoped></style>
